import { createContext, useContext, useEffect, useState } from "react";
import { bootstrapAuthentication } from "../Service/apiURL";
import {
  getAuthenticationSession,
  subscribeToAuthentication,
} from "../Service/authSession";

const AuthContext = createContext(getAuthenticationSession());

export const AuthProvider = ({ children }) => {
  const [session, setSession] = useState(getAuthenticationSession);

  useEffect(
    () =>
      subscribeToAuthentication(() => {
        setSession({ ...getAuthenticationSession() });
      }),
    [],
  );

  useEffect(() => {
    if (getAuthenticationSession().status === "loading") {
      bootstrapAuthentication();
    }
  }, []);

  return <AuthContext.Provider value={session}>{children}</AuthContext.Provider>;
};

export const useAuthSession = () => useContext(AuthContext);
